<template>
  <div class="auth">
    <div class="auth_in">
      <sign-in
        v-if="
          getFormState === 'signIn' || getFormState === 'forceChangePassword'
        "
      ></sign-in>
      <refresh-password
        v-if="
          getFormState === 'refreshPassword' ||
          getFormState === 'refreshPasswordSubmit'
        "
      ></refresh-password>
      <br />
      <br />
      <div v-if="getFormState === 'signUp'">
        <p v-on:click="toSignIn" class="toggle">
          すでにユーザー登録済みですか? サインインはこちら
        </p>
        <br />
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line
import SignIn from "./SignIn";
import RefreshPassword from "./RefreshPassword";
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";

export default {
  computed: mapGetters(["getFormState", "getLoginState", "getLanguage"]),
  name: "app",
  mounted() {
    if (this.getLoginState) {
      this.$router.push("/mytop");
    }
  },
  methods: {
    ...mapMutations(["setValueToFormState"]),

    toRefreshPassword() {
      this.$store.commit("setValueToFormState", "refreshPassword");
    },
    toSignUp() {
      this.$store.commit("setValueToFormState", "signUp");
    },
    toSignIn() {
      this.$store.commit("setValueToFormState", "signIn");
    },
  },
  components: {
    SignIn,
    RefreshPassword,
  },
};
</script>

<style lang="scss">
$xs: "320px";
$sm: "480px";
$md: "800px";
.btn_next {
  display: inline-block;
  color: #fff;
  font-size: 18px;
  padding: 12px 20px 12px 12px;
  min-width: 240px;
  text-align: center;
  background-color: #ff7600;
  border-radius: 28px;
  margin: 8px;
  box-shadow: 0 2px 4px 0px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  @media screen and (max-width: $md) {
    margin: 24px 0 0;
  }
  &:hover {
    opacity: 0.9;
  }
  &.is-negative {
    opacity: 0.5;
    cursor: default;
    &:hover {
      opacity: 0.5;
    }
  }
  &-lg {
    padding: 16px 24px 16px 16px;
    font-size: 24px;
    letter-spacing: 0.05em;
    border-radius: 36px;
    font-weight: bold;
    min-width: 280px;
    &::after {
      top: 24px;
      right: 28px;
    }
  }
}
.auth {
  background: #5592c6;
  min-height: calc(100vh - 94px);
  @media screen and (max-width: $md) {
    padding: 16px;
  }
  &_in {
    width: 600px;
    margin: 0 auto;
    background: #f3f3f3;
    border-radius: 4px;
    padding: 36px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
    @media screen and (max-width: $md) {
      width: 100%;
    }
  }
  &_btnArea {
    text-align: center;
  }
  .btn_next {
    max-width: 320px;
  }
}
.toggle {
  font-size: 10px;
}
.mail_text {
  font-size: 14px;
}
</style>
